import React from 'react';
import { Field } from 'react-final-form';
import { InfoPanel, TextField } from '@unite-us/app-components';
import { FIELD_NAMES, LABEL_CLASSNAME } from '../../constants';

const NOTE_INFO_MESSAGE =
  'Include only the information necessary to provide the requested services. ' +
  'Don\'t include sensitive information (e.g., interpersonal violence, ' +
  'substance use, or legal services information).';

export function NoteField() {
  return (
    <Field name={FIELD_NAMES.note}>
      {({ input, meta }) => (
        <div data-testid="structured-interaction-note">
          <TextField
            {...input}
            className="!p-0 col-span-2"
            id="structured-interaction-note"
            label="Note (optional)"
            labelClassName={LABEL_CLASSNAME}
            afterLabelContent={(
              <InfoPanel
                message={NOTE_INFO_MESSAGE}
                color="text-blue"
              />
            )}
            placeholder="Enter your note here …"
            error={meta.touched ? meta.error : undefined}
            invalid={meta.touched && Boolean(meta.error)}
            touched={meta.touched}
          />
        </div>
      )}
    </Field>
  );
}
